import React from "react";
import { cn } from "@/lib/utils";

// Full-height page shell: black grid backdrop with a centered content column.
const PageContainer = ({ children, outerClassName = "", innerClassName = "" }) => {
  return (
    <div
      className={cn(
        "bg-grid relative isolate min-h-screen overflow-hidden text-fg",
        outerClassName
      )}
    >
      <div
        className={cn(
          "relative mx-auto flex min-h-screen w-full max-w-6xl flex-col px-4 pb-16 pt-20 sm:px-8 md:px-12 md:pt-24",
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
